import { fromJS } from 'immutable';
import { get } from 'lodash';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  result: [],
  categories: {},
});

// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPICS: {
      const categoryIds = get(
        action,
        ['payload', 'topics', 'result', 'categories'],
        [],
      );

      if (!categoryIds.length) {
        return state;
      }

      return state
        .mergeIn(
          ['categories'],
          fromJS(action.payload.topics.entities.categories),
        )
        .set('result', categoryIds || state.get('result'));
    }

    default:
      return state;
  }
};
